import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './styles';

const getIconStyle = icon => {
  switch (icon.style) {
    case 'regular':
      return ['far', icon.symbol];
    case 'solid':
      return icon.symbol;
    case 'light':
      return ['fal', icon.symbol];
    case 'brand':
      return ['fab', icon.symbol];
    default:
      return icon.symbol;
  }
};

const BlankState = ({ image, icon, title, subtitle, action }) => (
  <Styles.BlankState>
    {image && <img src={image} alt={title} />}
    {icon && <FontAwesomeIcon icon={getIconStyle(icon)} />}
    <h4>{title}</h4>
    <p>{subtitle}</p>
    {action && (
      <Button variant={action.style || 'success'} onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </Styles.BlankState>
);

BlankState.defaultProps = {
  image: null,
  icon: null,
  action: null
};

BlankState.propTypes = {
  image: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  action: PropTypes.object
};

export default BlankState;
